module.exports = __webpack_public_path__ + "static/media/banner-clients-07.a052f772.jpg";